import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import QR from 'qrcode';
import jsPDF from 'jspdf';
import * as qs from 'query-string';
import { ApiHelper } from '../../../helpers';
import { ApiRoutes } from '../../../config';
import Loader from '../../components/loader/Loader';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ProgressBar } from 'react-bootstrap';

export const DownloadQRCode = () => {
  const { search } = useLocation();
  const { id, unit } = useParams();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0); // from 0 to 100

  useEffect(() => {
    document.body.classList.remove('bg-gradient-primary');
  }, []);

  useEffect(() => {
    async function fetchData() {
      const query = qs.parse(search);
      let data = {
        batchGroup: query?.group,
        batchId: id,
        unit,
        orderDate: query?.orderDate,
        batchIds: query?.batchIds || '',
      };
      if (query?.assignee) {
        data.clientId = query.assignee;
      }

      setLoading(true);
      const response = await new ApiHelper().FetchFromServer(
        ApiRoutes.FETCH_ASSIGNED_BATCH.service,
        ApiRoutes.FETCH_ASSIGNED_BATCH.url,
        ApiRoutes.FETCH_ASSIGNED_BATCH.method,
        ApiRoutes.FETCH_ASSIGNED_BATCH.authenticate,
        data
      );

      if (!response?.isError) {
        generatePDF(response.data.data)
      }

    }

    fetchData();
  }, [id, unit]);


  const generatePDF = async (data) => {
    const CHUNK_SIZE = 1000;
    const pageSize = 29;
    const qrSize = 18;
    const logoHeight = 4;
    const logoMarginTop = 2;
    const gap = 2;

    const zip = new JSZip();
    const logoUrl = `${window.location.origin}/img/color-logo.png`;

    const getBase64FromPublicImage = async (url) => {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };

    const logoData = await getBase64FromPublicImage(logoUrl);
    const totalChunks = Math.ceil(data.length / CHUNK_SIZE);

    const processChunk = async (chunkIndex = 0) => {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, data.length);
      const chunk = data.slice(start, end);

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [pageSize, pageSize],
      });

      for (let i = 0; i < chunk.length; i++) {
        const unit = chunk[i];
        const code = unit?.id?.toString() || '';

        const canvas = document.createElement('canvas');
        await new Promise((resolve, reject) => {
          QR.toCanvas(canvas, code, { width: qrSize * 5, margin: 0 }, (err) => {
            if (err) reject(err);
            else resolve();
          });
        });

        const imgData = canvas.toDataURL('image/png');

        const logoWidth = pageSize - 10;
        const logoX = (pageSize - logoWidth) / 2;
        doc.addImage(logoData, 'PNG', logoX, logoMarginTop, logoWidth, logoHeight);

        const qrY = logoMarginTop + logoHeight + gap;
        const qrX = (pageSize - qrSize) / 2.5;
        doc.addImage(imgData, 'PNG', qrX, qrY, qrSize, qrSize);

        doc.setFontSize(4);
        const textX = pageSize - 3.5;
        const textY = pageSize - 3;
        doc.text(code, textX, textY, { angle: 90, align: 'left' });

        if (i < chunk.length - 1) {
          doc.addPage([pageSize, pageSize]);
        }
      }

      const pdfBlob = doc.output('blob');
      zip.file(`qr_batch_${chunkIndex + 1}.pdf`, pdfBlob);
      setProgress(Math.min(100, ((chunkIndex + 1) / totalChunks) * 100));

      if (chunkIndex + 1 < totalChunks) {
        setTimeout(() => processChunk(chunkIndex + 1), 0);
      } else {
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        saveAs(zipBlob, 'batch.zip');
        setProgress(100);
        setLoading(false);
        window.close();
      }
    };

    await processChunk(0);
  };



  return (
    <div className='container mt-4'>
      {loading && (
        <div className="text-center mt-4">
          <p>Generating PDF...</p>
          <ProgressBar animated now={progress} variant='#0f51a1' />
          <p className='mt-2'>{progress.toFixed(1)}%</p>
        </div>
      )}
    </div>
  );
};